// store/createGenericSlice.js
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DefaultState {
    data: object;
    valid: boolean;
    loaded: boolean;
    loading: boolean;
    error: null | string;
}

export interface DefaultResponse {
    status: 'success' | 'error';
    payload?: object;
    message?: string;
}

export const createGenericSlice = <T>({ name, initialState, asyncThunk, extraReducers = () => { } }: any) => {
    return createSlice({
        name,
        initialState: createDefaultState<T>(initialState),
        reducers: {},
        extraReducers: (builder) => {
            createDefaultAsyncReducers<T>(builder, asyncThunk);
            extraReducers(builder)
        },
    });
};

// store/commonExtraReducers.js
export const createDefaultAsyncReducers = <T>(builder: any, asyncThunk: any) => {
    builder
        .addCase(asyncThunk.pending, (state: DefaultState) => {
            state.loading = true;
            state.loaded = false;
            state.error = null;
        })
        .addCase(asyncThunk.fulfilled, (state: DefaultState, action: PayloadAction<T>) => {
            state.loading = false;
            state.loaded = true;
            state.data = action.payload || [];
            state.error = null;
        })
        .addCase(asyncThunk.rejected, (state: DefaultState, action: any) => {
            state.loading = false;
            state.loaded = false;
            state.error = action.error.message || null;
        });
};

export interface GenericState<T> {
    data: T;
    valid: boolean;
    loaded: boolean;
    loading: boolean;
    error: string | null;
}

export const createDefaultState = <T>(data: T): GenericState<T> => ({
    data,
    valid: true,
    loaded: false,
    loading: false,
    error: null,
});